/* KX collection cards: colour dots preview / choose a variant (image, price, cart id), feature thumbnails. No libraries. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  $$('[data-kx-card]').forEach(function (card) {
    var img = $('[data-kx-cimg]', card);
    if (!img) return;
    var feature = card.hasAttribute('data-kx-feature');
    var base = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' };
    var chosen = null, tok = 0;
    var dots = $$('[data-kx-dot]', card), thumbs = $$('[data-kx-fthumb]', card);
    var price = $('[data-kx-cprice]', card), half = $('[data-kx-chalf]', card), label = $('[data-kx-clabel]', card);
    var idInput = $('input[name="id"]', card), atcText = $('.kx-atc .text', card), links = $$('[data-kx-clink]', card);

    function setImg(src, srcset) {
      if (!src) return;
      var t = ++tok;
      if (img.getAttribute('src') === src) { img.classList.remove('is-swap'); return; }
      img.classList.add('is-swap');
      var pre = new Image();
      pre.sizes = img.getAttribute('sizes') || '';
      if (srcset) pre.srcset = srcset;
      pre.src = src;
      var done = function () {
        if (t !== tok) return;
        img.srcset = srcset || '';
        img.src = src;
        requestAnimationFrame(function () { img.classList.remove('is-swap'); });
      };
      if (pre.decode) pre.decode().then(done, done); else { pre.onload = done; pre.onerror = done; }
    }
    function preview(d) {
      var s = d.getAttribute('data-img');
      if (!s) return;
      card.classList.add('is-swatch');
      setImg(s, d.getAttribute('data-srcset'));
    }
    function restore() {
      if (chosen && chosen.getAttribute('data-img')) { setImg(chosen.getAttribute('data-img'), chosen.getAttribute('data-srcset')); return; }
      if (!feature) card.classList.remove('is-swatch');
      setImg(base.src, base.srcset);
    }
    function choose(d) {
      chosen = d;
      dots.forEach(function (x) { var on = x === d; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var p = d.getAttribute('data-price'), h = d.getAttribute('data-half'), href = d.getAttribute('data-href') || d.getAttribute('href');
      if (price && p) price.textContent = p;
      if (half && h) half.textContent = h;
      if (label) label.textContent = d.getAttribute('data-label') || '';
      if (idInput && d.getAttribute('data-vid')) idInput.value = d.getAttribute('data-vid');
      if (atcText && p) atcText.textContent = (atcText.getAttribute('data-base') || '') + ' · ' + p;
      if (href) links.forEach(function (a) { a.setAttribute('href', href); });
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      preview(d);
    }
    dots.forEach(function (d) {
      d.addEventListener('mouseenter', function () { preview(d); });
      d.addEventListener('mouseleave', restore);
      d.addEventListener('focus', function () { preview(d); });
      d.addEventListener('blur', restore);
      if (feature) d.addEventListener('click', function (e) { e.preventDefault(); choose(d); });
    });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === b); });
        base = { src: b.getAttribute('data-img'), srcset: b.getAttribute('data-srcset') || '' };
        chosen = null;
        setImg(base.src, base.srcset);
      });
    });
  });
})();